module.exports = __webpack_public_path__ + "img/Rectangle 17.5d028018.png";